module.exports = __webpack_public_path__ + "img/index_pic1.aeae9a5a.png";